import {
    GET_DASHBOARD_INFO,
    GET_DASHBOARD_INFO_FAIL,
    GET_DASHBOARD_INFO_SUCCESS,
    GET_DASHBOARD_OPTIONS,
    GET_DASHBOARD_OPTIONS_FAIL,
    GET_DASHBOARD_OPTIONS_SUCCESS,
    RESET_DASHBOARD_STATE
  } from "./actionTypes";
  
  export const getDashboardInfo = (payload) => ({
    type: GET_DASHBOARD_INFO,
    payload: payload,
  });
  
  export const getDashboardInfoSuccess = general => ({
    type: GET_DASHBOARD_INFO_SUCCESS,
    payload: general,
  });
  
  export const getDashboardInfoFail = error => ({
    type: GET_DASHBOARD_INFO_FAIL,
    payload: error,
  });
  
  export const getDashboardOptions = (payload) => ({
    type: GET_DASHBOARD_OPTIONS,
    payload: payload,
  });
  
  export const getDashboardOptionsSuccess = general => ({
    type: GET_DASHBOARD_OPTIONS_SUCCESS,
    payload: general,
  });
  
  export const getDashboardOptionsFail = error => ({
    type: GET_DASHBOARD_OPTIONS_FAIL,
    payload: error,
  });

  //reset
  export const resetDashboardState = () => {
    return {
        type: RESET_DASHBOARD_STATE,
    }
  }